module.exports = __webpack_public_path__ + "wxMicroService/img/negative.4435f558.png";